import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faShoppingCart, 
  faPhone, 
  faEnvelope,
  faDownload,
  faChevronRight
} from "@fortawesome/free-solid-svg-icons";
import { Offcanvas, Badge } from "react-bootstrap";
import "./Header.css";
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import myIcon from '../Assets/carticon.png';
import logo from '../Assets/logo.png';

function Header() {
  const [cartCount, setCartCount] = useState(0);
  const [storeClose, setStoreClose] = useState(0);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [contactData, setContactData] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  
  // Scroll effect for header
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const fetchContactData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}content.php`);
        const { body } = response.data;
        setContactData(body.contact);
        setStoreClose(Number(body.store_close));
      } catch (error) {
        console.error("Error fetching the contact data", error);
      }
    };
    fetchContactData();
  }, []);

  useEffect(() => {
    const count = parseInt(localStorage.getItem("cartCount")) || 0;
    setCartCount(count);

    const handleStorageChange = () => {
      const count = parseInt(localStorage.getItem("cartCount")) || 0;
      setCartCount(count);
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const handleClose = () => setShowOffcanvas(false);
  const handleShow = () => setShowOffcanvas(true);

  const handleDownloadPriceList = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}download_pricelist.php`,
        { responseType: 'blob' }
      );

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'PriceList.pdf');
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
      alert('Failed to download price list. Please try again later.');
    }
  };

  return (
    <div className={`nav-main ${isScrolled ? 'scrolled' : ''}`}>
      {/* Top Bar */}
      <div className="topbar">
        <div className="container">
          <div className="contact-infos">
            <div className="contact-item">
              <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
              <span className="contact-text">{contactData?.email || "info@example.com"}</span>
            </div>
            <div className="contact-item">
              <FontAwesomeIcon icon={faPhone} className="contact-icon" />
              <span className="contact-text">{contactData?.phonenumber || "+1 234 567 8900"}</span>
            </div>
          </div>
          
          <div className="social-links">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link">
              <i className="bi bi-facebook"></i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link">
              <i className="bi bi-instagram"></i>
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-link">
              <i className="bi bi-youtube"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className={`header ${isScrolled ? 'header-scrolled' : ''}`}>
        <div className="container">
          {/* Logo with Text */}
          <Link to="/home" className="logo">
            {/* <img src={logo} alt="Yuvathi Sparks Logo" className="logo-img" /> */}
            <span className="logo-text">Yuvathi Sparks</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="nav-menu">
            <ul className="nav-list">
              <li className="nav-item">
                <Link to="/home" className="nav-link">
                  <span className="nav-text">Home</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/quick" className="nav-link">
                  <span className="nav-text">Enquiry</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/about" className="nav-link">
                  <span className="nav-text">About Us</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/contact" className="nav-link">
                  <span className="nav-text">Contact Us</span>
                </Link>
              </li>
            </ul>
          </nav>

          {/* CTA Buttons */}
          <div className="header-actions">
            <Button 
              className="price-list-btn btn-primary" 
              onClick={handleDownloadPriceList}
            >
              <FontAwesomeIcon icon={faDownload} className="btn-icon" />
              <span>Price List</span>
            </Button>
            
            {storeClose === 0 && (
              <div className="cart-wrapper">
                <Link to="/cart" className="cart-link">
                  <div className="cart-icon-wrapper">
                    <img src={myIcon} alt="Cart" className="cart-icon" />
                    {cartCount > 0 && (
                      <Badge bg="danger" className="cart-badge">
                        {cartCount}
                      </Badge>
                    )}
                  </div>
                </Link>
              </div>
            )}

            {/* Mobile Menu Toggle */}
            <button 
              className="mobile-menu-toggle" 
              onClick={handleShow}
              aria-label="Toggle menu"
            >
              <span className="toggle-bar"></span>
              <span className="toggle-bar"></span>
              <span className="toggle-bar"></span>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Offcanvas Menu */}
      <Offcanvas 
        show={showOffcanvas} 
        onHide={handleClose} 
        placement="end"
        className="mobile-menu"
      >
        <Offcanvas.Header className="mobile-menu-header">
          <Offcanvas.Title className="mobile-menu-title">
            {/* <img src={logo} alt="Yuvathi Sparks" className="mobile-logo" /> */}
            <span className="mobile-logo-text">Yuvathi Sparks</span>
          </Offcanvas.Title>
          <button className="mobile-menu-close" onClick={handleClose}>
            &times;
          </button>
        </Offcanvas.Header>
        <Offcanvas.Body className="mobile-menu-body">
          <ul className="mobile-nav-list">
            <li className="mobile-nav-item">
              <Link to="/home" className="mobile-nav-link" onClick={handleClose}>
                <i className="bi bi-house-fill mobile-nav-icon"></i>
                <span>Home</span>
                <FontAwesomeIcon icon={faChevronRight} className="nav-arrow" />
              </Link>
            </li>
            <li className="mobile-nav-item">
              <Link to="/quick" className="mobile-nav-link" onClick={handleClose}>
                <i className="bi bi-bag-fill mobile-nav-icon"></i>
                <span>Enquiry</span>
                <FontAwesomeIcon icon={faChevronRight} className="nav-arrow" />
              </Link>
            </li>
            <li className="mobile-nav-item">
              <Link to="/about" className="mobile-nav-link" onClick={handleClose}>
                <i className="bi bi-info-circle-fill mobile-nav-icon"></i>
                <span>About Us</span>
                <FontAwesomeIcon icon={faChevronRight} className="nav-arrow" />
              </Link>
            </li>
            <li className="mobile-nav-item">
              <Link to="/contact" className="mobile-nav-link" onClick={handleClose}>
                <i className="bi bi-telephone-fill mobile-nav-icon"></i>
                <span>Contact Us</span>
                <FontAwesomeIcon icon={faChevronRight} className="nav-arrow" />
              </Link>
            </li>
          </ul>
          
          <div className="mobile-menu-footer">
            <Button 
              className="mobile-price-list-btn" 
              onClick={() => {
                handleDownloadPriceList();
                handleClose();
              }}
            >
              <FontAwesomeIcon icon={faDownload} />
              Download Price List
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}

export default Header;